import { Injectable } from '@angular/core';
import { EPlatformFeature } from '@enums/campaign.enum';
import { TExpectedKpi } from '@interfaces/campaign-analytics.interface';
import { ComponentStore } from '@ngrx/component-store';
import { EMPTY, MonoTypeOperatorFunction, Observable, pipe } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { ExpectedKpiListService } from './execution-expected-kpi-list/execution-expected-kpis/expected-kpi-list/expected-kpi-list.service';

interface IExpectedKpiStepState {
  availableKpis: TExpectedKpi[] | null;
  error: string | null;
}

const initialState: IExpectedKpiStepState = {
  availableKpis: null,
  error: null,
};

@Injectable()
export class ExpectedKpiStepStore extends ComponentStore<IExpectedKpiStepState> {
  public readonly availableKpis$ = this.selectSignal((state: IExpectedKpiStepState) => state.availableKpis);
  public readonly error$ = this.selectSignal((state: IExpectedKpiStepState) => state.error);

  private readonly handleError = (errorMessage: string): MonoTypeOperatorFunction<unknown> =>
    pipe(
      catchError(() => {
        this.patchState({
          availableKpis: [],
          error: errorMessage,
        });

        return EMPTY;
      }),
    );

  public readonly fetchAvailableKpis = this.effect((trigger$: Observable<EPlatformFeature>) => {
    return trigger$.pipe(
      tap(() => this.patchState({ availableKpis: null, error: null })),
      switchMap((platformFeature: EPlatformFeature) => {
        return this.expectedKpiListService.getPlatformFeatureKpisGoal(platformFeature).pipe(
          tap((availableKpis: TExpectedKpi[]) => {
            this.patchState({ availableKpis });
          }),
          this.handleError('Failed to load available kpis'),
        );
      }),
    );
  });

  constructor(private readonly expectedKpiListService: ExpectedKpiListService) {
    super(initialState);
  }
}
